module.exports = __webpack_public_path__ + "static/img/Font_logoW@2x.19d0d7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Font_logoW@2x.png
// module id = LC4i
// module chunks = 0